import { StateAbbreviation } from '@mortgage-pos/types'

// Some states mandate a minimum rate-lock period. Sending a shorter lock makes
// MQ stop every quote (e.g. "Lock Period: 45 Day Lock Min in Oklahoma"), so the
// borrower sees no rates at all. Borrower-facing rate requests override the lock
// period for these states instead of changing the global pricing default, which
// would affect every rate consumer. Add states here as we confirm them.
export const STATE_MINIMUM_LOCK_PERIOD: Partial<
  Record<StateAbbreviation, number>
> = {
  [StateAbbreviation.Ok]: 45,
}
